import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Devuelve el catálogo público (productos custom desde backend) + fallback del hardcoded.
 */
export default function useCustomProducts() {
  const [custom, setCustom] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.listProducts();
      setCustom(Array.isArray(data) ? data : []);
    } catch {
      setCustom([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return { custom, loading, refresh };
}
